import React from "react";
import { Link } from "react-router-dom";

type Variant = "primary" | "outline" | "ghost" | "white" | "custom";

type Size = "sm" | "md" | "lg";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  fullWidth?: boolean;
  to?: string; // when provided, renders a react-router Link
}

const variantClasses: Record<Variant, string> = {
  primary: "bg-navy text-white hover:bg-navy/90",
  outline: "border border-gray-200 text-gray-700 hover:bg-gray-50",
  ghost: "bg-transparent text-navy hover:bg-navy/5",
  white: "bg-white text-navy hover:bg-gray-50",
  custom: "", // bg를 className으로만 제어
};

const sizeClasses: Record<Size, string> = {
  sm: "px-3 py-2 text-[1.4rem]",
  md: "px-8 py-3 text-[1.6rem]",
  lg: "px-8 py-4 text-[1.8rem]",
};

const base =
  "inline-flex items-center justify-center rounded-[6px] font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed ";

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const {
    variant = "primary",
    size = "md",
    className = "",
    fullWidth = false,
    to,
    children,
    ...rest
  } = props;

  const classes = `${base} ${variantClasses[variant]} ${sizeClasses[size]} ${
    fullWidth ? "w-full" : ""
  } ${className}`.trim();

  if (to) {
    // Render as Link when `to` prop is provided
    return (
      <Link to={to} className={classes} {...(rest as any)}>
        {children}
      </Link>
    );
  }

  return (
    <button ref={ref} className={classes} {...rest}>
      {children}
    </button>
  );
});

Button.displayName = "Button";

export default Button;
